module.exports = __webpack_public_path__ + "img/2024-07-01d_4.8083defe.jpg";